import { Typography, Button, Space } from 'antd';

const { Title, Paragraph } = Typography;

export function FinalCTA() {
  return (
    <section
      style={{
        padding: '80px 24px',
        background: 'linear-gradient(135deg, #001529 0%, #112a45 100%)',
        color: '#ffffff',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <Title
          level={2}
          style={{
            color: '#ffffff',
            fontSize: 'clamp(28px, 4.5vw, 48px)',
            marginBottom: '24px',
            fontWeight: 700,
          }}
        >
          Stop Building Subscription Infrastructure
        </Title>
        <Paragraph
          style={{
            color: 'rgba(255, 255, 255, 0.85)',
            fontSize: '18px',
            marginBottom: '40px',
            lineHeight: 1.6,
          }}
        >
          Focus on your product. Let iSubscribe handle plans, access,
          entitlements, and monetization.
        </Paragraph>
        <Space size="middle" wrap style={{ justifyContent: 'center' }}>
          <Button
            type="primary"
            size="large"
            href="/login"
            style={{
              height: '52px',
              padding: '0 40px',
              fontSize: '16px',
              fontWeight: 'bold',
              background: '#ffffff',
              color: '#001529',
              border: 'none',
            }}
          >
            Start Free Trial
          </Button>
          <Button
            ghost
            size="large"
            href="#demo"
            style={{
              height: '52px',
              padding: '0 40px',
              fontSize: '16px',
              fontWeight: 'bold',
              borderColor: '#ffffff',
              color: '#ffffff',
            }}
          >
            Schedule Demo
          </Button>
        </Space>
      </div>
    </section>
  );
}
